/**
 * ウィッシュリストヘルパー関数
 * ウィッシュリスト機能のユーティリティ関数
 */

(function(window) {
  'use strict';

  // レスポンス構造を解析するヘルパー関数（複数の可能なデータ構造を処理）
  function parseResponseData(data, keys = []) {
    if (!data) return null;
    
    // データが既に配列の場合は、それを返す
    if (Array.isArray(data)) {
      return data;
    }
    
    // キーでデータを検索（例: 'lists', 'items', 'products'）
    for (const key of keys) {
      if (data[key] && Array.isArray(data[key])) {
        return data[key];
      }
    }
    
    // ネストされたデータ構造を試す: data.data[key]
    if (data.data) {
      if (Array.isArray(data.data)) {
        return data.data;
      }
      for (const key of keys) {
        if (data.data[key] && Array.isArray(data.data[key])) {
          return data.data[key];
        }
      }
    }
    
    return null;
  }

  // グローバル名前空間にエクスポート
  window.WishlistHelper = {
    parseResponseData: parseResponseData
  };

})(window);

